/**
 * Ticket T3a: Einheitliche Normalisierung der Adressen (Slugs) von
 * TTPA-Transparenzseiten. Client-sicher, damit Backend-Editor und
 * automatische Erzeugung dieselbe Regel verwenden.
 */

/** Maximale Länge einer TTPA-Adresse. */
export const TTPA_SLUG_MAX_LENGTH = 60;

/**
 * Pfade, die vom System selbst belegt sind bzw. für öffentliche Seiten
 * reserviert bleiben müssen. Eine Transparenzseite darf keinen davon belegen.
 */
export const RESERVED_TTPA_SLUGS: readonly string[] = [
  "admin",
  "api",
  "auth",
  "blog",
  "cases",
  "cockpit",
  "datenschutz",
  "downloads",
  "impressum",
  "kontakt",
  "login",
  "logout",
  "robots",
  "sitemap",
  "termin",
  "ttpa",
  "transparenz",
  "vorlage",
];

/**
 * Normalisiert eine beliebige Eingabe (Wunsch-Kürzel oder Name) zu einer
 * TTPA-Adresse: Kleinschreibung, Umlaute und ß umgeschrieben, Sonder- und
 * Leerzeichen zu einzelnen Bindestrichen, keine Bindestriche am Rand,
 * maximal 60 Zeichen.
 */
export function normalizeTtpaSlug(input: string): string {
  const base = (input ?? "")
    .toLowerCase()
    .replace(/ä/g, "ae")
    .replace(/ö/g, "oe")
    .replace(/ü/g, "ue")
    .replace(/ß/g, "ss")
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, TTPA_SLUG_MAX_LENGTH)
    .replace(/-+$/g, "");
  return base;
}

/** Prüft, ob eine Adresse einen reservierten Systempfad belegen würde. */
export function isReservedTtpaSlug(slug: string): boolean {
  return RESERVED_TTPA_SLUGS.includes(slug);
}

/**
 * Normalisiert und weicht reservierten Systempfaden aus (`admin` →
 * `admin-transparenz`). Leere Eingaben ergeben `transparenzangaben`.
 */
export function normalizeTtpaSlugSafe(input: string): string {
  const slug = normalizeTtpaSlug(input);
  if (slug === "") return "transparenzangaben";
  if (!isReservedTtpaSlug(slug)) return slug;
  return normalizeTtpaSlug(`${slug}-transparenz`) || "transparenzangaben";
}
